import React, { useState } from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";

const TabMenuContainer = styled.div`
  position: relative;
  width: 175px;
`;

const TabMenuHeader = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e5e5e5;
  font-weight: 600;
  font-size: 19px;
  cursor: pointer;
  background: #151e3d;
  text-transform: uppercase;

  &:hover {
    opacity: 0.9;
  }

  ${({ active }) =>
    active &&
    css`
      background: #11172c;
    `}
`;

const TabMenuListContainer = styled.div`
  position: absolute;
  margin-top: 0px;
  z-index: 3;
  width: 100%;
`;

const TabMenuList = styled.ul`
  padding: 0;
  margin: 0;
  background: #151e3d;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: #e5e5e5;
  font-size: 20px;
  font-weight: 500;
  height: 250px;
  overflow: hidden;
  overflow-y: scroll;
  cursor: pointer;

  ${({ theme }) =>
    theme.screenWidth < 900 &&
    css`
      font-size: 14px;
    `}

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #151e3d;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      height: 0;
      border: none;
    `}
`;

const ListItem = styled.li`
  list-style: none;
  padding: 10px;
  &:hover {
    background: #11172c;
  }
`;

const TabMenu = ({ title, menuItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => menuItems && setIsOpen(true);
  const close = () => menuItems && setIsOpen(false);

  return (
    <TabMenuContainer
      data-test="tab-menu-container"
      onMouseOver={open}
      onMouseLeave={close}
    >
      <TabMenuHeader active={isOpen}>{title}</TabMenuHeader>
      <TabMenuListContainer>
        {isOpen && (
          <TabMenuList isEmpty={isEmpty(menuItems)} data-test="tab-menu-list">
            {menuItems.map((item, idx) => (
              <ListItem key={idx}>{item}</ListItem>
            ))}
          </TabMenuList>
        )}
      </TabMenuListContainer>
    </TabMenuContainer>
  );
};

TabMenu.propTypes = {
  title: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TabMenu;
